import type { Mouvement } from '@mairistem/comptabilite';

import { isEmpty } from 'lodash';

const getTotalPj = (mouvement: Mouvement): number => {
	if (!isEmpty(mouvement.informationPieceJointe)) {
		return (
			Number(mouvement.informationPieceJointe.match(/_PJ=(\d+)/)?.[1]) || 0
		);
	}
	return 0;
};

export default getTotalPj;
